import NotFoundPage from '@modules/system/pages/NotFoundPage';
import NotAuthPage from '@modules/system/pages/NotAuthPage';
import { IRouteConfig } from './route.types';
import DashBoard from '@app/pages/MainDashboardPage';
import { schoolServiceModuleRoute } from './school-service-route';
import { baoCaoSgdModuleRoute } from './bao-cao-sgd-route';

export type { IRouteConfig };

const notFoundRoute: IRouteConfig = {
    name: 'Không tìm thấy trang',
    path: '*',
    isMenu: false,
    isRoute: true,
    exact: false,
    main: () => <NotFoundPage />,
};

const notAuthRoute: IRouteConfig = {
    name: 'Không có quyền truy cập',
    path: '/not-authorized',
    link: '/not-authorized',
    isMenu: false,
    isRoute: true,
    exact: false,
    main: () => <NotAuthPage />,
};

const defaultRoute: IRouteConfig = {
    name: 'Dashboard',
    path: '/',
    link: '',
    isMenu: false,
    isRoute: true,
    exact: false,
    isAuth: true,
    main: () => <DashBoard />,
};
export const menuRoutes: IRouteConfig[] = [
    defaultRoute,
    schoolServiceModuleRoute,
    baoCaoSgdModuleRoute,
    notAuthRoute,
    notFoundRoute,
];
